import { Form, Input } from 'antd';
import React, { useState } from 'react';

interface PriceInputProps {
  onChange?: (value: any) => void;
  placeholder?: string;
  value?: any;
  name: any;
  rules?: any;
  form: any;
  isCommon: boolean;
}

export const formatNumber = (value: number) => {
  return value.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const PriceInputSegment: React.FC<PriceInputProps> = ({ form, onChange, placeholder, name, isCommon }) => {
  const [inputValue, setInputValue] = useState<string>('0');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const numericValue = parseFloat(rawValue?.replace(/[^0-9.]/g, ''));
    if (isCommon) {
      const currentValues = form.getFieldValue('price_common');
      const existingItem = currentValues[name] || {};
      if (!isNaN(numericValue)) {
        currentValues[name] = {
          ...existingItem,
          price: formatNumber(numericValue),
        };
      } else {
        currentValues[name] = {
          ...existingItem,
          price: 0,
        };
      }
      form.setFieldsValue({
        price_common: currentValues,
      });
    } else {
      const currentValues = form.getFieldValue('price_json');
      if (!isNaN(numericValue)) {
        currentValues[name] = {
          name: currentValues[name].name,
          price: formatNumber(numericValue),
        };
        form.setFieldsValue({
          price_json: currentValues,
        });
      } else {
        currentValues[name] = {
          name: currentValues[name].name,
          price: 0,
        };
        form.setFieldsValue({
          price_json: currentValues,
        });
      }
    }
    if (onChange) onChange(formatNumber(numericValue));
  };

  // Hàm định dạng số với dấu phân tách phần ngàn
  return (
    <Form.Item
      name={[name, 'price']}
      className="form-item-name required"
      validateTrigger={['onChange', 'onBlur']}
      dependencies={['is_diagram']}
      rules={[
        ({ getFieldValue }) => ({
          validator(_: any, value: any) {
            if (getFieldValue('is_diagram')) {
              if (value) {
                const data = Number(value?.replace(/,/g, ''));
                if (data === 0 || !data) {
                  return Promise.reject(new Error('Vui lòng nhập giá nhóm ghế'));
                } else {
                  if (data > 100000000) {
                    return Promise.reject(new Error('Vui lòng nhập tối đa 100,000,000'));
                  } else {
                    return Promise.resolve();
                  }
                }
              } else {
                return Promise.reject(new Error('Vui lòng nhập giá nhóm ghế'));
              }
            } else {
              return Promise.resolve();
            }
          },
        }),
      ]}
    >
      <Input value={inputValue} onChange={handleChange} placeholder={placeholder ?? ''} addonAfter="đ" />
    </Form.Item>
  );
};

export default PriceInputSegment;
